<template>
	<div class="colors">
		<h4 class="text-uppercase" v-if="render_colors.length">Color</h4>
		<div class="color-container">
			<div class="colors" v-for="color in render_colors">
				<div class="square" :style="`background-color: ${ color.color }`" data-toggle="tooltip" :title="color.color_name" @click="selectColor($event, color)"></div>
			</div>
		</div>
		<!-- <button class="btn btn-black" @click="selectColor($event, null)">Reiniciar color</button> -->
	</div>
</template>

<script>
import { filterColor } from '../../store/actions';
import { router } from '../../routes/routes';

export default {
	vuex: {
		getters: {
			colors: state => state.colors
		},
		actions: {
			filterColor
		}
	},

	computed: {
		render_colors () {
			setTimeout(() => {
				$('[data-toggle="tooltip"]').tooltip();
			}, 0);

			return this.colors;
		}
	},

	methods: {
		selectColor (e, color) {
			var route = `/${ this.$route.name }?`;

			// If has page query.
			if (this.$route.query.page)
				route += `page=1`;

			// If has more queries append a &.
			if (this.$route.query.page && this.$route.query.filter)
				route += '&';

			// If has filter query.
			if (this.$route.query.filter)
				route += `filter=${ this.$route.query.filter }`;

			if ($(e.target).hasClass('active')) {
				$(e.target).removeClass('active');
				router.go(route);
				return this.filterColor(0);
			}

			$('.square').removeClass('active');
			$(e.target).addClass('active');
			router.go(route);
			this.filterColor(color.color);
		}
	},

	ready () {
		this.filterColor(0);
	}
}
</script>


// WEBPACK FOOTER //
// Color.vue?098d231f